// Exaltation Forge (como no Global, custos em gold do Global — decisão do Arthur).
// Classes 1 a 4 (tier máximo 1, 2, 3 e 10). Fusão: 2 itens iguais do mesmo tier → 1 item com tier+1; 50% de sucesso
// (+15% com um exalted core); na falha um item some e o outro perde 1 tier (50% de chance de não perder com outro core).
// Transferência: o tier de um item vai para outro da mesma classe com 1 tier a menos. Dust: 100 por fusão ou transferência;
// 20 dust = 1 sliver (em lotes de 3); 50 slivers = 1 exalted core; limite de 225 dust.
// Dust e slivers caem dos monstros especiais das hunts (o papel dos Influenced e Fiendish do Tibia).
export const CLASS_MAX_TIER: Record<number, number> = { 1: 1, 2: 2, 3: 3, 4: 10 };
/** preço (gold) e cores da fusão para chegar ao tier `to`, por classe (item_tiers.lua do Canary) */
export const FORGE_PRICE: Record<number, Array<[number, number]>> = {
  1: [[25_000, 1]],
  2: [[750_000, 1], [5_000_000, 1]],
  3: [[4_000_000, 1], [10_000_000, 2], [20_000_000, 3]],
  4: [[8_000_000, 1], [20_000_000, 2], [40_000_000, 5], [65_000_000, 10], [100_000_000, 15], [250_000_000, 25], [750_000_000, 35], [2_500_000_000, 50], [8_000_000_000, 60], [15_000_000_000, 80]],
};
export const FORGE = { fusionDust: 100, transferDust: 100, baseChance: 50, coreBonus: 15, tierLossReduction: 50, dustPerSliver: 20, sliverBatch: 3, coreSlivers: 50, maxDust: 225 };
/** chance (%) dos efeitos de tier: Onslaught (armas, +60% de dano) e Ruse (armaduras, esquiva) */
export const TIER_CHANCE = [0, 0.5, 1.05, 1.65, 2.3, 3.0, 3.75, 4.55, 5.4, 6.3, 7.25];
export const ONSLAUGHT_DMG = 60;
/** fórmulas oficiais dos efeitos de tier (config.lua do Canary: a·tier² + b·tier + c), em % */
const POLY: Record<string, [number, number, number]> = {
  onslaught: [0.05, 0.4, 0.05], ruse: [0.0307576, 0.440697, 0.026], momentum: [0.05, 1.9, 0.05], transcendence: [0.0127, 0.107, 0.0073], amplification: [0.4, 1.7, 0.4],
};
export type TierEffect = keyof typeof POLY;
export function tierChance(effect: TierEffect, tier: number): number {
  if (!tier) return 0;
  const [a, b, c] = POLY[effect]!;
  return a * tier * tier + b * tier + c;
}
/** Transcendence: avatar por 7 s */
export const TRANSCENDENCE_MS = 7000;
/** dust e slivers por monstro especial (Super / Mega / Ultra) */
export const ELITE_DUST: Record<number, [number, number]> = { 1: [1, 3], 2: [3, 6], 3: [6, 12] };
export const ELITE_SLIVERS: Record<number, [number, number]> = { 3: [3, 7] };
